import { useFrozenCardDrop } from '../frozenDrop.store';

import FrozenDropCardContent from './FrozenDropCardContent/FrozenDropCardContent';

import type { JSX } from 'react';

/**
 * Renders a frozen copy of the dropped card, snapped into the target cell,
 * while the plan/unassign call + refetch resolve. Replaces the vanished native
 * drag ghost so the user keeps seeing the card at its new spot during the load
 * state. Presentation only; the lifecycle (set on drop, cleared on settle) is
 * owned by `CardsViewPragmatic` / `RosterViewPragmatic`.
 */
const FrozenDropCardPragmatic = (): JSX.Element | null => {
  'use memo';
  const frozenDrop = useFrozenCardDrop();

  if (!frozenDrop) return null;

  // Keyed per drop so each drop starts fresh (visible again), even for
  // back-to-back drops of the same card, where the value is replaced without
  // clearing first and only `dropId` differs.
  return (
    <FrozenDropCardContent key={frozenDrop.dropId} frozenDrop={frozenDrop} />
  );
};

export default FrozenDropCardPragmatic;
